import React from 'react'
import { useTranslation } from 'react-i18next'

import ModalForm from '../../common/modal-form'
import IconClose from '../../../assets/icons/IconClose'
import WrapIcon from '../../elements/WrapIcon'

import { COLOR_NAME } from '../../../constants'
import { getFoodPriceShow } from '../../../utils'
import useMoney from '../../../hooks/useMoney'
import { getFullFileUrl } from '../../../utils/formatData'
import { clsx } from '../../../utils/helper'

import FormatCurrency from '../../elements/FormatCurrency'
import Button from '../../elements/Button'

import disableMask from '../../../assets/images/disable-mask.png';
import useFood from '../../../hooks/useFood'

const FoodChoiceItem = ({ food, onClick, selected, hasInCart }) => {
    const { currentPrice, originPrice } = useMoney(getFoodPriceShow, food);
    const { isFoodSoldOut } = useFood(food);

    return (
        <div
            className={clsx(
                'food-choice__item',
                hasInCart && 'has-in-cart',
                selected && 'selected',
                isFoodSoldOut && 'sold-out'
            )}
            onClick={() => !isFoodSoldOut && onClick()}
        >
            <div className="selected-icon">
                <i className="fas fa-check-circle" />
            </div>
            {food.imagePath && (
                <div className="food-img">
                    <img className="image" alt="" src={getFullFileUrl(food.imagePath)} />
                    <img alt="disable-mask" className="disable-mask" src={disableMask} />
                </div>
            )}
            <div className="food-info">
                <div className="food-name">{food.name}</div>
                {food.description && (
                    <div className="food-description">{food.description}</div>
                )}
                <div className="food-price">
                    <FormatCurrency amount={currentPrice} />
                    <div className="food-price__origin">
                        {!!originPrice && <FormatCurrency amount={originPrice} />}
                    </div>
                </div>
            </div>
        </div>
    )
}

const FoodChoice = ({
    foods,
    isOpen,
    handleSelectFood,
    handleClose,
    foodIndexSelected,
    handleSubmitSelectFood,
    currentFoodPrice,
}) => {
    const { t } = useTranslation()

    return (
        <ModalForm rootClass="food-choice label-2" isOpen={isOpen} centered>
            <div className="food-choice__head">
                <WrapIcon
                    onClick={handleClose}
                    size="24px"
                    icon={IconClose}
                    color={COLOR_NAME.MODAL_ICON}
                    className="food-choice__head-close"
                />
                <div className="food-choice__head__name">
                    {foods?.[0]?.parent?.name}
                </div>
                <div className="food-choice__head__title">
                    {t('modalFoodChoose.title')}
                </div>
            </div>

            <div className="food-choice__list">
                {foods.map((food, index) => (
                    <FoodChoiceItem
                        food={food}
                        onClick={() => handleSelectFood(index)}
                        key={index}
                        selected={foodIndexSelected === index}
                        hasInCart={food.hasInCart}
                    />
                ))}
            </div>

            <div className="submit-select">
                <Button
                    disabled={foodIndexSelected === -1}
                    onClick={handleSubmitSelectFood}
                >
                    {t('modalFoodChoose.btnAgree') + ' '}
                    (<FormatCurrency amount={currentFoodPrice} />)
                </Button>
            </div>
        </ModalForm>
    )
}

export default FoodChoice
